<template>
  <v-touch @swipe="touching" class="scroll w-full h-screen overflow-hidden relative">
    <div @wheel="scrolling" class="entrance-bg init" v-show="process < 10">
      <router-link to="/main" class="absolute text-white font-bold"
                   style="top: 10%; right: 10%; z-index: 100000;"
      >
        >> Skip
      </router-link>
      <canvas
          id="canvas"
          :width="`${$store.state.windowWidth}px`"
          :height="`${$store.state.windowHeight}px`"
      ></canvas>
      <div class="circle1 circle">
        <img src="@/assets/images/pages/entrance/circle1.svg" class="w-full">
      </div>
      <div class="circle2 circle">
        <img src="@/assets/images/pages/entrance/circle2.svg" class="w-full">
      </div>
      <div class="circle3 circle">
        <img src="@/assets/images/pages/entrance/circle3.svg" class="w-full">
      </div>
      <div class="circle4 circle">
        <img src="@/assets/images/pages/entrance/circle4.svg" class="lg:w-full w-4/5">
      </div>
      <div class="circle5 circle">
        <img src="@/assets/images/pages/entrance/circle5.svg" class="lg:w-full w-4/5">
      </div>
      <div class="circle6 circle" @click="enterClick = true">
        <img src="@/assets/images/pages/entrance/circle6.svg" class="lg:w-full w-4/5">
      </div>
      <div class="circle7 circle" @click="enterClick = true">
        <img src="@/assets/images/pages/entrance/circle7.svg" class="lg:w-full w-4/5">
      </div>
      <div class="circle8 circle" @click="enterClick = true">
        <img src="@/assets/images/pages/entrance/circle8.svg" class="lg:w-full w-4/5">
      </div>
      <div class="circle9 circle" @click="enterClick = true">
        <img src="@/assets/images/pages/entrance/circle9.svg" class="lg:w-full w-1/2">
      </div>
      <div
          class="enter"
          @click="enterClick = true"
      >
        <div class="pointer">
          ENTER METARISING
        </div>
      </div>
    </div>
    <canvas
        @wheel="scrolling"
        id="canvas_video"
        :width="`${$store.state.windowWidth}px`"
        :height="`${$store.state.windowHeight}px`"
    >
    </canvas>
  </v-touch>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'entrance',
  data: () => ({
    enter: false,
    enterClick: false,
    process: 0,
    videoSeek: 0,
    videoTimer: null,
    story: null,
    images: [],
    imageSeq: 0
  }),
  watch: {
    enterClick (val) {
      if (val) {
        //7936
        const procTimer = setInterval(() => {
          if (this.process >= 10) {
            this.process = 100
            clearInterval(procTimer)
          } else {
            this.process++
          }
        }, 28)
      } else if (this.videoTimer) {
        clearInterval(this.videoTimer)
        this.videoTimer = null
      }
    },
    process (val) {
      // console.log(val)
      this.$gsap.to(this.story, 1, {
        progress: val / 10
      })

      if (val > 10) {
        this.enter = true
      }
    }
  },
  methods: {
    scrolling (event) {
      if (event.deltaY > 0) {
        this.process = this.process > 27 ? 28 : this.process + 1
      } else {
        this.process = this.process < 1 ? 0 : this.process - 1
      }
    },
    touching (event) {
      if (event.deltaY < 0) {
        this.process = this.process > 27 ? 28 : this.process + 1
      } else {
        this.process = this.process < 1 ? 0 : this.process - 1
      }
    },
    initImages () {
      for (let i = 1; i <= 185; i++) {
        const img = new Image()
        img.src = require(`@/assets/images/cave/cave${i}.jpg`)
        this.images.push(img)
      }
      this.videoTimer = setInterval(() => {
        if (this.imageSeq === 184) {
          clearInterval(this.videoTimer)
          this.videoTimer = null
          this.$router.push('/main')
        } else if (this.process > (this.imageSeq / this.images.length).toFixed(0)) {
          this.imageSeq++
          this.render()
        } else if (this.process < (this.imageSeq / this.images.length).toFixed(0)) {
          this.imageSeq--
          this.render()
        }
      }, 28)
    },
    render () {
      const canvas = document.getElementById('canvas_video')
      const img = this.images[this.imageSeq]
      if (img) {
        const hRatio = canvas.width / img.width
        const vRatio = canvas.height / img.height
        const ratio = Math.max(hRatio, vRatio)
        const centerShift_x = (canvas.width - img.width * ratio) / 2
        const centerShift_y = (canvas.height - img.height * ratio) / 2
        const context = canvas.getContext('2d')
        context.clearRect(0, 0, canvas.width, canvas.height)
        //this.images[this.imageSeq]
        context.drawImage(img, 0, 0, img.width, img.height,
            centerShift_x, centerShift_y, img.width * ratio, img.height * ratio)
      }
    }
  },
  mounted () {
    const canvas = document.getElementById('canvas')
    this.initImages()
    this.story = new this.$gsap.timeline({paused: true})
        .fromTo('.init', {
          opacity: 1,
          scale: 1
        }, {
          opacity: 0,
          scale: 3,
          ease: 'cubic-bezier(0.67, 0.01, 0.32, 1)',
          duration: 1
        })
        .fromTo('#canvas_video', {
          scale: 0,
          opacity: 0
        }, {
          opacity: 1,
          scale: 1
        }, '-=1')
        .call(() => {
          this.$store.commit('TOGGLE_APP_CLASSES', ['bg-white', 'bg-black'])
        })

    // animation
    let ctx = canvas.getContext('2d'),
        hue = 217,
        stars = [],
        count = 0,
        maxStars = 1400
    // Cache gradient
    let canvas2 = document.createElement('canvas'),
        ctx2 = canvas2.getContext('2d')
    canvas2.width = 100
    canvas2.height = 100
    let half = canvas2.width / 2,
        gradient2 = ctx2.createRadialGradient(half, half, 0, half, half, half)
    gradient2.addColorStop(0.025, '#fff')
    gradient2.addColorStop(0.1, `hsl(${hue}, 61%, 33%)`)
    gradient2.addColorStop(0.25, `hsl(${hue}, 64%, 6%)`)
    gradient2.addColorStop(1, 'transparent')

    ctx2.fillStyle = gradient2
    ctx2.beginPath()
    ctx2.arc(half, half, half, 0, Math.PI * 2)
    ctx2.fill()

    function random (min, max) {
      if (arguments.length < 2) {
        max = min
        min = 0
      }

      if (min > max) {
        const hold = max
        max = min
        min = hold
      }

      return Math.floor(Math.random() * (max - min + 1)) + min
    }

    function maxOrbit (x, y) {
      let max = Math.max(x, y),
          diameter = Math.round(Math.sqrt(max * max + max * max))
      return diameter / 2
    }

    const that = this
    const Star = function () {
      this.orbitRadius = random(maxOrbit(that.$store.state.windowWidth, that.$store.state.windowHeight))
      this.radius = random(60, this.orbitRadius) / 12
      this.orbitX = that.$store.state.windowWidth / 2
      this.orbitY = that.$store.state.windowHeight / 2
      this.timePassed = random(0, maxStars)
      this.speed = random(this.orbitRadius) / 50000
      this.alpha = random(2, 10) / 10

      count++
      stars[count] = this
    }

    Star.prototype.draw = function () {
      let x = Math.sin(this.timePassed) * this.orbitRadius + this.orbitX,
          y = Math.cos(this.timePassed) * this.orbitRadius + this.orbitY,
          twinkle = random(10)

      if (twinkle === 1 && this.alpha > 0) {
        this.alpha -= 0.05
      } else if (twinkle === 2 && this.alpha < 1) {
        this.alpha += 0.05
      }

      ctx.globalAlpha = this.alpha
      ctx.drawImage(canvas2, x - this.radius / 2, y - this.radius / 2, this.radius, this.radius)
      this.timePassed += this.speed
    }

    for (let i = 0; i < maxStars; i++) {
      new Star()
    }

    const animation = () => {
      ctx.globalCompositeOperation = 'source-over'
      ctx.globalAlpha = 0.8
      ctx.fillStyle = `hsla(${hue}, 64%, 6%, 1)`
      ctx.fillRect(0, 0, this.$store.state.windowWidth, this.$store.state.windowHeight)

      ctx.globalCompositeOperation = 'lighter'
      for (let i = 1, l = stars.length; i < l; i++) {
        stars[i].draw()
      }

      window.requestAnimationFrame(animation)
    }

    animation()
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
      appLoading.style.display = 'none'
    }
  },
  beforeDestroy () {
    if (this.videoTimer) {
      clearInterval(this.videoTimer)
      this.videoTimer = null
    }

    if (this.story) {
      this.story.kill()
    }
  }
}
</script>

<style scoped lang="scss">
div::v-deep {
  .entrance-bg {
    position: relative;
    //background-image: url('~@/assets/images/pages/entrance/entrance.svg');
    //background-position: center;
    //background-repeat: no-repeat;
    //background-size: cover;
    width: 100%;
    height: 100%;
    //background: #060e1b;
    overflow: hidden;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    .circle {
      position: absolute;
      //left: 50%;
      //top: 50%;
      //transform: translate(-50%, -50%);
      display: flex;
      justify-content: center;
      align-items: center;

    }


    .enter {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      padding: 100px 50px;
      animation: light 2s linear infinite;

      .router-link-active {
        color: #fff;
      }

      &::after {
        content: '';
        position: absolute;
        width: 9px;
        height: 9px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        background: #FFFFFF;
        box-shadow: 0px 1px 7px #FFFFFF;
      }

      &:hover {
        cursor: pointer;
      }

      @media screen and (max-width: 1024px) {
        font-size: 16px;

        &::after {
          left: -7%;
          width: 5px;
          height: 5px;
        }
      }
    }

    @keyframes light {
      0% {
        text-shadow: 0px 1px 14px #FFFFFF;
      }
      50% {
        text-shadow: none;
      }
      100% {
        text-shadow: 0px 1px 14px #FFFFFF;
      }

    }

    .circle1,
    .circle3,
    .circle5,
    .circle8 {
      animation: scale1 2s 0s linear infinite;
    }

    .circle2,
    .circle4,
    .circle7, {
      animation: scale1 5s 0s linear infinite;
    }


    @keyframes scale1 {
      0% {
        transform: scale(1);
        opacity: 0;

      }
      50% {
        opacity: 1;
      }
      100% {
        transform: scale(1.2);
        opacity: 0;
      }

    }
    @media screen and (max-width: 1024px) {
      @keyframes scale1 {
        0% {
          transform: scale(1);
          opacity: 0;

        }
        50% {
          opacity: 1;
        }
        100% {
          transform: scale(2.5);
          opacity: 0;
        }
      }
    }

  }

  .video {
    position: absolute;
    top: 0;
    transition: all .5s ease;
    opacity: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1;
    object-fit: cover;
    margin-left: 50%;
    transform: translateX(-50%);

    @media screen and (max-aspect-ratio: 1219/685) {
      width: auto;
      height: 100vh;
    }

    &.scroll-on {
      opacity: 1;
      //transform: scale(1);
    }

    &.x-trans-50 {
      //transform: translateX(-50%);
    }

    &.y-trans-50 {
      //transform: translateY(-50%);
    }
  }
}

</style>
